// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "f53da16c1200";
export const BUILD_VERSION_NUMBER = 7;
